const smokingStatus = {
  NotSmoking: 1,
  SmokingCurrently: 2,
  SmokedInPast: 3
}

export default smokingStatus;